import './mainPage.css';

import { Link } from 'react-router-dom';
import { FaArrowLeft, FaMinus, FaPlus, FaShoppingBag, FaTrash } from 'react-icons/fa';
import AnnouncementBar from './AnnouncementBar';
import Footer from './Footer';
import Header from './Header';
import { navItems } from './data/mockData';
import { useCart } from './CartContext';

const currencyFormatter = new Intl.NumberFormat('es-CR', {
  style: 'currency',
  currency: 'CRC',
  maximumFractionDigits: 0,
});

const CartPage = () => {
  const { items, itemCount, subtotal, updateQuantity, removeItem, clearCart, checkout } = useCart();

  return (
    <div className="app-shell">
      <AnnouncementBar />
      <Header navItems={navItems} />

      <main className="section container cart-view">
        <Link to="/" className="product-details-back">
          <FaArrowLeft /> Seguir comprando
        </Link>

        <div className="cart-heading">
          <div>
            <span>Carrito de compras</span>
            <h1>Tu bolsa</h1>
            <p>
              {itemCount
                ? `${itemCount} producto(s) listos para revisar.`
                : 'Agrega productos desde la tienda para preparar tu pedido.'}
            </p>
          </div>
          {items.length ? (
            <button type="button" className="cart-clear-button" onClick={clearCart}>
              Vaciar carrito
            </button>
          ) : null}
        </div>

        {!items.length ? (
          <section className="cart-empty-state">
            <FaShoppingBag />
            <h2>Tu carrito esta vacio</h2>
            <p>Busca vestidos, blusas, accesorios o promociones y agregalos a tu bolsa.</p>
            <Link to="/" className="secondary-button">
              Ver productos
            </Link>
          </section>
        ) : (
          <section className="cart-layout">
            <div className="cart-items">
              {items.map((item) => (
                <article className="cart-item" key={item.cartKey}>
                  <img src={item.image} alt={item.name} />

                  <div className="cart-item-info">
                    <h2>{item.name}</h2>
                    {item.storeName ? <span>{item.storeName}</span> : null}
                    {item.options?.length ? (
                      <div className="cart-item-options">
                        {item.options.map((option) => (
                          <small key={option}>{option}</small>
                        ))}
                      </div>
                    ) : null}
                    {item.code ? <small>Codigo: {item.code}</small> : null}
                  </div>

                  <div className="cart-item-controls">
                    <div className="cart-quantity-control">
                      <button
                        type="button"
                        aria-label={`Restar ${item.name}`}
                        onClick={() => updateQuantity(item.cartKey, item.quantity - 1)}
                      >
                        <FaMinus />
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        type="button"
                        aria-label={`Sumar ${item.name}`}
                        onClick={() => updateQuantity(item.cartKey, item.quantity + 1)}
                        disabled={item.available !== null && item.available !== undefined && item.quantity >= item.available}
                      >
                        <FaPlus />
                      </button>
                    </div>
                    <strong>{currencyFormatter.format(item.price * item.quantity)}</strong>
                    <button
                      type="button"
                      className="cart-remove-button"
                      aria-label={`Quitar ${item.name}`}
                      onClick={() => removeItem(item.cartKey)}
                    >
                      <FaTrash />
                    </button>
                  </div>
                </article>
              ))}
            </div>

            <aside className="cart-summary">
              <h2>Resumen</h2>
              <div>
                <span>Productos</span>
                <strong>{itemCount}</strong>
              </div>
              <div>
                <span>Subtotal</span>
                <strong>{currencyFormatter.format(subtotal)}</strong>
              </div>
              <p>El total final puede variar por envio, disponibilidad o promociones aplicadas al confirmar.</p>
              <button type="button" className="add-cart-button" onClick={checkout}>
                Continuar pedido
              </button>
            </aside>
          </section>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default CartPage;
